var map = {
	"./de/triangle-icon.png": "67ss",
	"./en/triangle-icon.png": "unlG",
	"./es/triangle-icon.png": "lsW2",
	"./fr/triangle-icon.png": "uIkk",
	"./ja/triangle-icon.png": "JGOn",
	"./ko/triangle-icon.png": "Oi4A",
	"./pt/triangle-icon.png": "UWP2",
	"./ru/triangle-icon.png": "XAkU",
	"./tc/triangle-icon.png": "oqYM",
	"./th/triangle-icon.png": "PuQU"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "OTpC";